export default "__VITE_ASSET__DUSZ7l2x__"